// extracted by mini-css-extract-plugin
export default {"Close":"Close_LXl9x_v17-8-1","Close__PositionAbsolute":"Close__PositionAbsolute_j5PT2_v17-8-1"};